import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';
import moment from "moment";

export default function ScheduleClassBox(props) {
  const {
    totalIndex,
    idx,
    data,
    canceledSchedules,
    conversionRate,
    onClickWeeklyScheduleBox,
    onClickDeletedClass
  } = props;

  const [isCanceled, setIsCanceled] = useState(false);

  const DeleteTotalRef = useRef();
  const DeleteBackgroundRef = useRef();
  const DeleteButtonRef = useRef();

  // 폐강 여부 확인 //
  useEffect(() => {
    for (let i = 0; i < canceledSchedules.length; i++) {
      if (data.classDate === moment(canceledSchedules[i].classDate).format('YYYY.MM.DD')
        && data.classTime === canceledSchedules[i].classTime
        && data.scheduleId === canceledSchedules[i].scheduleId) {
          setIsCanceled(true);
          return;
        } 
    }
  }, [data, canceledSchedules])

  // 호버링 배경색 컬러 코드에서 RGB값으로 변경 //
  function hexToRGB(hex, alpha) {
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);

    if (alpha) return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ")";
    else return 'rgba(' + r + ', ' + g + ', ' + b + ")";
  }
  
  // 테두리 형태 및 색상 결정 //
  function decideBorder() {
    if (data.className === '수업없음') return '1px solid #ECECEC';
    else if (isCanceled) return '1px dashed ' + data.color;
    else return '1px solid ' + data.color;
  }

  // 호버링시 테두리 형태 및 색상 결정 //
  function decideHoverBorder() {
    if (data.className === '수업없음') return '1px solid #ECECEC';
    else if (isCanceled) return '1px dashed ' + data.color;
    else return '2px solid ' + data.color;
  }

  // 수업 시간에 따른 크기 변환 계산 //
  function onCalcTDHeight() {
    let startTime = data.classTime.split('-')[0];
    let endTime = data.classTime.split('-')[1];

    let startTimeHour = parseInt(startTime.split(':')[0]);
    let startTimeMinute = parseInt(startTime.split(':')[1]);

    let endTimeHour = parseInt(endTime.split(':')[0]);
    let endTimeMinute = parseInt(endTime.split(':')[1]);

    let startValue = 0;
    let endValue = 0;

    if (startTimeMinute >= 55) startValue = startTimeHour + 0.91;
    else if (startTimeMinute >= 50) startValue = startTimeHour + 0.83;
    else if (startTimeMinute >= 45) startValue = startTimeHour + 0.75;
    else if (startTimeMinute >= 40) startValue = startTimeHour + 0.66;
    else if (startTimeMinute >= 35) startValue = startTimeHour + 0.58;
    else if (startTimeMinute >= 30) startValue = startTimeHour + 0.5;
    else if (startTimeMinute >= 25) startValue = startTimeHour + 0.41;
    else if (startTimeMinute >= 20) startValue = startTimeHour + 0.33;
    else if (startTimeMinute >= 15) startValue = startTimeHour + 0.25;
    else if (startTimeMinute >= 10) startValue = startTimeHour + 0.16;
    else if (startTimeMinute >= 5) startValue = startTimeHour + 0.08;
    else startValue = startTimeHour;

    if (endTimeMinute >= 55) endValue = endTimeHour + 0.91;
    else if (endTimeMinute >= 50) endValue = endTimeHour + 0.83;
    else if (endTimeMinute >= 45) endValue = endTimeHour + 0.75;
    else if (endTimeMinute >= 40) endValue = endTimeHour + 0.66;
    else if (endTimeMinute >= 35) endValue = endTimeHour + 0.58;
    else if (endTimeMinute >= 30) endValue = endTimeHour + 0.5;
    else if (endTimeMinute >= 25) endValue = endTimeHour + 0.41;
    else if (endTimeMinute >= 20) endValue = endTimeHour + 0.33;
    else if (endTimeMinute >= 15) endValue = endTimeHour + 0.25;
    else if (endTimeMinute >= 10) endValue = endTimeHour + 0.16;
    else if (endTimeMinute >= 5) endValue = endTimeHour + 0.08;
    else endValue = endTimeHour;

    let finalRate = endValue - startValue;

    if (finalRate < 1.5) return 66;
    else return (((finalRate - 1) * conversionRate) + 1) * 66;
  }

  // 수업 시간에 따른 크기 변환 ( 호버링 전용 ) 계산 //
  function onCalcHoverTDHeight() {
    let startTime = data.classTime.split('-')[0];
    let endTime = data.classTime.split('-')[1];

    let startTimeHour = parseInt(startTime.split(':')[0]);
    let startTimeMinute = parseInt(startTime.split(':')[1]);

    let endTimeHour = parseInt(endTime.split(':')[0]);
    let endTimeMinute = parseInt(endTime.split(':')[1]);

    let startValue = 0;
    let endValue = 0;

    if (startTimeMinute >= 55) startValue = startTimeHour + 0.91;
    else if (startTimeMinute >= 50) startValue = startTimeHour + 0.83;
    else if (startTimeMinute >= 45) startValue = startTimeHour + 0.75;
    else if (startTimeMinute >= 40) startValue = startTimeHour + 0.66;
    else if (startTimeMinute >= 35) startValue = startTimeHour + 0.58;
    else if (startTimeMinute >= 30) startValue = startTimeHour + 0.5;
    else if (startTimeMinute >= 25) startValue = startTimeHour + 0.41;
    else if (startTimeMinute >= 20) startValue = startTimeHour + 0.33;
    else if (startTimeMinute >= 15) startValue = startTimeHour + 0.25;
    else if (startTimeMinute >= 10) startValue = startTimeHour + 0.16;
    else if (startTimeMinute >= 5) startValue = startTimeHour + 0.08;
    else startValue = startTimeHour;

    if (endTimeMinute >= 55) endValue = endTimeHour + 0.91;
    else if (endTimeMinute >= 50) endValue = endTimeHour + 0.83;
    else if (endTimeMinute >= 45) endValue = endTimeHour + 0.75;
    else if (endTimeMinute >= 40) endValue = endTimeHour + 0.66;
    else if (endTimeMinute >= 35) endValue = endTimeHour + 0.58;
    else if (endTimeMinute >= 30) endValue = endTimeHour + 0.5;
    else if (endTimeMinute >= 25) endValue = endTimeHour + 0.41;
    else if (endTimeMinute >= 20) endValue = endTimeHour + 0.33;
    else if (endTimeMinute >= 15) endValue = endTimeHour + 0.25;
    else if (endTimeMinute >= 10) endValue = endTimeHour + 0.16;
    else if (endTimeMinute >= 5) endValue = endTimeHour + 0.08;
    else endValue = endTimeHour;

    let finalRate = endValue - startValue;

    if (isCanceled) {
      if (finalRate < 1.5) return 66;
      else return ((((finalRate - 1) * conversionRate) + 1) * 66);
    }
    else {
      if (finalRate < 1.5) return 64;
      else return ((((finalRate - 1) * conversionRate) + 1) * 66) - 2;
    }
  }

  // 수업 컴포넌트 개별 호버링 시 //
  function onMouseEnterTimeComponent() {
    DeleteTotalRef.current.style.opacity = `1`;
  }

  // 수업 컴포넌트 개별 호버링시 //
  function onMouseLeaveTimeComponent() {
    DeleteTotalRef.current.style.opacity = `0`;
  }

  // 수업삭제 버튼 호버링시 //
  function onMouseEnterDeleteButton() {
    DeleteBackgroundRef.current.style.width = '125px';
    DeleteBackgroundRef.current.style.height = `100%`;
    DeleteBackgroundRef.current.style.borderRadius = '4px';
  }

  // 수업삭제 버튼 호버리시 //
  function onMouseLeaveDeleteButton() {
    DeleteBackgroundRef.current.style.margin = '0px';
    DeleteBackgroundRef.current.style.width = '20px';
    DeleteBackgroundRef.current.style.height = '17px';
    DeleteBackgroundRef.current.style.borderRadius = '15px 0px 0px 90px';
  }

  function onClickWeeklyScheduleBoxIn(e) {
    if (DeleteButtonRef.current.contains(e.target)) return;

    onClickWeeklyScheduleBox(data);
  }

  return (
    <Box
      isCanceled={isCanceled}
      onClick={(e) => onClickWeeklyScheduleBoxIn(e)}
      isValid={data.className !== '수업없음'}
      height={onCalcTDHeight()}
      hoverHeight={onCalcHoverTDHeight()}
      // color={data.className === '수업없음' ? '#ECECEC' : data.color}
      border={decideBorder()}
      hoverBorder={decideHoverBorder()}
      backgroundColor={isCanceled ? `#FFFFFF` : data.color}
      hoverBackgroundColor={isCanceled ? `#FFFFFF` : hexToRGB(data.color, 0.8)}
      onMouseEnter={onMouseEnterTimeComponent}
      onMouseLeave={onMouseLeaveTimeComponent}>
      <DeleteButtonWrapper 
        ref={DeleteTotalRef}>
        <DeleteBackground
          ref={DeleteBackgroundRef}
          backgroundColor={hexToRGB('#FF3131', 0.4)}>
          <DeleteButton
            ref={DeleteButtonRef}
            onMouseEnter={() => onMouseEnterDeleteButton(totalIndex, idx)}
            onMouseLeave={() => onMouseLeaveDeleteButton(totalIndex, idx)}
            onClick={() => onClickDeletedClass(data, 'Component')}>
            <DeleteIcon src={WhiteTrashIcon} />
          </DeleteButton>
        </DeleteBackground>
      </DeleteButtonWrapper>
      <TextWrapper>
        <ClassNameWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={12} color={isCanceled ? `#969696` : `#FFFFFF`} cursor='pointer'>{data.className}</Text>
        </ClassNameWrapper>
        <ClassTimeWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={isCanceled ? `#969696` : `#FFFFFF`} cursor='pointer'>{data.classTime + (isCanceled ? ' (폐강)' : '')}</Text>
        </ClassTimeWrapper>
        <CoachNameWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color={isCanceled ? `#969696` : `#FFFFFF`} cursor='pointer'>{data.teacherName}</Text>
        </CoachNameWrapper>
      </TextWrapper>
    </Box>
  )
}

const Box = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 121px;
  height: ${props => props.height}px;

  // border: 1px solid ${props => props.color};
  border: ${props => props.border};
  border-radius: 4px;
  background-color: ${props => props.backgroundColor};

  :hover {
    width: ${props => props.isCanceled ? `121px` : `119px`};
    height: ${props => props.hoverHeight}px;

    // border: 2px solid ${props => props.color};
    border: ${props => props.hoverBorder};
    cursor: ${props => props.isValid ? `pointer` : `default`};
    background-color: ${props => props.hoverBackgroundColor};
  }
`;


const DeleteButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin-top: -2px;

  // width: 125px;
  width: 123px;
  height: calc(100% + 4px);

  z-index: 5;
  opacity: 0;

  overflow: hidden;
  background-color: transparent;
`;

const DeleteBackground = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  z-index: 3;

  width: 20px;
  height: 17px;

  border-radius: 15px 0px 0px 90px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 17px;

  border-radius: 0px 4px 0px 4px;
  background-color: #FF3131;

  z-index: 6;

  :hover {
    cursor: pointer;
  }

  transition: none;
`;

const DeleteIcon = styled.img`
  width: 12px;
  height: 12px;
`;

const ClassNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 110px;
  height: 17px;

  overflow: hidden;
`;

const ClassTimeWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 110px;
  height: 16px;

  overflow: hidden;
`;

const CoachNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 110px;
  height: 15px;

  overflow: hidden;
`;

const TextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 2px;
  margin-left: -16px;

  width: 93px;
  height: 50px;

  z-index: 4;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }
`;